/* eslint-disable */
// Time-off requests — ported from the prototype's `timeOff` useState initializer
// (dros-beta-prototype_524.html ~37606). Dates are today-relative (generated),
// exactly as the prototype did, so the pending/decided split stays realistic.

import { TimeOffRequest } from '../../models';

interface PersonaLite {
  id: string;
  name: string;
}

export function buildTimeOffRequests(personas: PersonaLite[]): TimeOffRequest[] {
  const nameById: Record<string, string> = {};
  personas.forEach((p) => (nameById[p.id] = p.name));
  const iso = (off: number) => {
    const x = new Date();
    x.setDate(x.getDate() + off);
    return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
  };
  const at = (off: number) => {
    const x = new Date();
    x.setDate(x.getDate() + off);
    return x.toISOString();
  };
  const nm = (id: string, fb: string) => nameById[id] || fb;
  return [
    { id: 'to_seed1', personaId: 'marcus', personaName: nm('marcus', 'Marcus Reyes'), start: iso(5), end: iso(7), reason: 'Pathway — out of town', status: 'pending', requestedAt: at(-1) },
    { id: 'to_seed2', personaId: 'brady', personaName: nm('brady', 'Brady'), start: iso(12), end: iso(12), reason: 'Doctor appointment', status: 'pending', requestedAt: at(-2) },
    { id: 'to_seed3', personaId: 'paulson', personaName: nm('paulson', 'Nathan Paulson'), start: iso(-6), end: iso(-4), reason: 'Personal', status: 'approved', requestedAt: at(-12), decidedAt: at(-10) },
    { id: 'to_seed4', personaId: 'whitmill', personaName: nm('whitmill', 'Johnathan Whitmill'), start: iso(-9), end: iso(-9), reason: 'Sick day', status: 'approved', requestedAt: at(-11), decidedAt: at(-10) },
    { id: 'to_seed5', personaId: 'marcus', personaName: nm('marcus', 'Marcus Reyes'), start: iso(-15), end: iso(-14), reason: 'Long weekend', status: 'denied', denialReason: 'Concrete pour scheduled those days — need full crew.', requestedAt: at(-20), decidedAt: at(-18) },
    { id: 'to_seed6', personaId: 'brady', personaName: nm('brady', 'Brady'), start: iso(20), end: iso(24), reason: 'Vacation — already booked', status: 'approved', requestedAt: at(-3), decidedAt: at(-1) },
  ];
}
